<template>
  <div
    class="payment-card"
    :class="{ 'payment-card--disabled': isExpired }"
    :aria-disabled="isExpired"
    @click="handleClick"
  >
    <div class="payment-card__header">
      <p class="payment-card__title">
        {{ paymentMethod }}
      </p>
      <div
        class="payment-card__status"
        :class="statusClass"
      >
        <svg-loader :src="`/static/images/${statusIcon}.svg`" />
      </div>
    </div>
    <div class="payment-card__info">
      <p class="payment-card__label">
        CÓDIGO: <span>{{ operationCode }}</span>
      </p>
      <p class="payment-card__label">
        DATA: <span>{{ formattedDate }}</span>
      </p>
    </div>
    <div class="payment-card__amount">
      {{ formattedAmount }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "PaymentStatusCard",
  props: {
    paymentMethod: { type: String, required: true },
    operationCode: { type: String, required: true },
    date: { type: String, required: true },
    amount: { type: Number, required: true },
    status: {
      type: String,
      required: true,
      validator: (value) =>
        ["PaymentConfirmed", "Pending", "Expired"].includes(value)
    }
  },
  computed: {
    formattedDate() {
      return moment(this.date).format("DD-MM-YYYY");
    },
    formattedAmount() {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(this.amount);
    },
    isExpired() {
      return this.status === "Expired";
    },
    statusClass() {
      return {
        "payment-card__status--pending": this.status === "Pending",
        "payment-card__status--paid": this.status === "PaymentConfirmed",
        "payment-card__status--expired": this.status === "Expired"
      };
    },
    statusIcon() {
      if (this.status === "PaymentConfirmed") return "icon-check-thin";
      if (this.status === "Pending") return "icon-dashboard-calendar-white";
      return "status-info-white";
    }
  },
  methods: {
    handleClick() {
      if (!this.isExpired) {
        this.$emit("card-clicked", this.operationCode);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  width: 225px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: opacity 0.3s;

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  &__title {
    font-size: 16px;
    font-weight: bold;
    color: #818181;
  }

  &__status {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    .md-icon {
      min-width: 18px;
      min-height: 18px;
      width: 18px;
      height: 18px;

      svg,
      path {
        fill: #fff !important;
      }
    }
  }

  &__status--pending {
    background-color: #f4a623;
  }

  &__status--paid {
    background-color: #52cc9c;
  }

  &__status--expired {
    background-color: #d64541;
  }

  &__icon {
    width: 20px;
    height: 20px;
  }

  &__info {
    font-size: 12px;
    color: #666;
    margin-bottom: 10px;
  }

  &__label {
    margin: 2px 0;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 4px;

    span {
      flex: 1;
      min-width: 0;
      font-weight: normal;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__amount {
    font-size: 24px;
    font-weight: bold;
    color: #7f1a54;
  }
}
</style>
